export default {
  list: (state) => state.list,
  userName: (state) => state.userName,
};
